import { Component, Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpEventType } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AppConfig } from '../app.config';
import * as _ from 'lodash';

@Injectable()
export class SCVService{

    
    isAuthenticated: boolean = false;

    customerAttachmentId: string;

    language: string;

    applicationName: string= "";

    status: string;

    uploadSessionId: string;

    brandCode:string 
    
    country :string
    customerConsent: boolean=false;

    numberOfFiles: number;

    private user : string = btoa(this.appConfig.getAppConfig().username+':'+this.appConfig.getAppConfig().password);

    constructor(private http: HttpClient,private appConfig:AppConfig){}

    uploadService(file: File): Observable<any>{
        let headers = new HttpHeaders({ 'Authorization': `Basic ${this.user}`});
        const formData: FormData = new FormData();
        formData.append('file',file,file.name);
        return this.http.post(`${this.appConfig.getAppConfig().scvUploadUrl}?customerAttachmentId=${this.customerAttachmentId}&uploadSessionId=${this.uploadSessionId}&customerConsent=${this.customerConsent}&applicationName=${this.applicationName}`,formData,{ headers ,reportProgress:true,observe:'events'});     
    }

    sizeOfUploadedFilesByCustomerAttachmentID(): Observable<any>{
        let headers = new HttpHeaders({ 'Authorization': `Basic ${this.user}`});
        return this.http.get(`${this.appConfig.getAppConfig().scvUploadUrl}/count?customerAttachmentId=${this.customerAttachmentId}`,{headers});     
    }

    
    validateToken(token: string): Observable<any>{
        let headers = new HttpHeaders({ 'Authorization': `Bearer ${token}`});
        return this.http.get(`${this.appConfig.getAppConfig().scvUploadUrl}/verifyQRcode`,{headers});
    }

    getConsentText() : Observable<any>{
        let headers = new HttpHeaders({ 'Content-Type': `text/html; charset=utf-8`});
        return this.http.get(`${this.appConfig.getAppConfig().scvUploadUrl}/consentText?brand=${this.brandCode}&language=${this.language}&country=${this.country}`,{responseType:'text'});
    }
    
    setIsAuthenticated(isValid: boolean){
        this.isAuthenticated = isValid;
    }

    IsAuthenticated(): boolean{
        return this.isAuthenticated;
    }

    setCustomerConsent(customerConsent: boolean){
        this.customerConsent = customerConsent;
    }

    getCustomerConsent(): boolean{
        return this.customerConsent;
    }

    setCustomerAttachmentId(customerAttachmentId: string){
        this.customerAttachmentId = customerAttachmentId;
    }

    setUploadSessionId(sessionId: string) {
        this.uploadSessionId = sessionId;

    }

    getUploadSessionId() {
        return this.uploadSessionId;
    }

    setApplicationName(appname: string){
        this.applicationName = appname;
    }

    setNumberOfFiles(numberOfFiles: number) {
        this.numberOfFiles= numberOfFiles;
    }

    getNumberOfFiles() : number {
        return this.numberOfFiles;
    }

    setLanguage(lang: string){
        this.language = lang;
    }

    getLanguage(){
        return this.language ;
    }

    setStatus(status: string){
        this.status = status;
    }

    getStatus(){
        return this.status ;
    }

    setBrandCode(brandCode: string) {
        this.brandCode = brandCode;
    }

    getBrandCode() {
        return this.brandCode;
    }

    setCountry(country: string) {
        this.country = country;
    }

    getCountry() {
        return this.country;
    }

}